import { FC, useEffect, useState } from 'react';
import { formatTime } from 'shared/lib/time';
import { BasicCard } from 'shared/ui/cards/basicCard';
import { GuestsIcon } from 'shared/ui/icons/guests';
import { TimeIcon } from 'shared/ui/icons/time';
import { Truncate } from 'shared/ui/truncate';
import flash from 'assets/icons/flash.svg';

import {
	CardContainer,
	CardContent,
	CardInfo,
	DepositWrapper,
	Icon,
	TimeContent,
	TimeText,
	Title,
} from '../styles/card';
import { GuestsCardProps } from '../types/components';
import { OrderResources, State } from 'entities/orders';
import { MenComingIcon } from 'shared/ui/icons/menComing';
import { TimerIcon } from 'shared/ui/icons/timer/timer';
import { Tooltip } from 'shared/ui/tooltip';
import { Flex } from 'shared/ui/flex';
import { OrderConfirm } from 'entities/orders/ui/ordersTableColumns/orderConfirm/orderConfirm';
import { OrderTagsShort } from 'entities/orders/ui/InfoPanel/components/OrderInfo/OrderTagsShort';
import { useResize } from 'app/lib/hooks/useResize';
import { Img } from 'shared/ui/imgStyledComponent';

export const GuestsCard: FC<GuestsCardProps> = ({ select, order, id, borderRadius = {} }) => {
	const [visitStart, setVisitStart] = useState('');
	const [visitEnd, setVisitEnd] = useState('');
  const [remakedTags, setRemakedTags] = useState<string[]>([]);

	const selectCardId = () => {
		select && select(order.id);
	};

  const { 
    width
  } = useResize();

	useEffect(() => {
		const start = formatTime({ time: order.appointment?.dt_start });
		const end = formatTime({ time: order.appointment?.dt_end });
		if (start && end) {
			setVisitStart(start.time);
			setVisitEnd(end.time);
		}
	}, [order]);
  
  useEffect(() => {
    if (!order.tags.length) return setRemakedTags([]);

    const arr = [];
    let maxWidth = 381;
    let tagsWidth = 0;
    let plusLength = order.tags.length;

    const paddings = 12 + ((4 + 1 + 16) * 2);
    if (width <= 1024) {
      maxWidth = (window.innerWidth / 2) - paddings
    }
    if (width <= 580) {
      maxWidth = window.innerWidth - paddings;
    }

    maxWidth -= 50;
  
    for (let index = 0; index < order.tags.length; index++) {
      const tag = order.tags[index];
      const span = document.createElement('span');
      span.innerHTML = tag;
      span.style.setProperty('padding', '0 10px');
      span.style.setProperty('white-space', 'nowrap');
      span.style.setProperty('font-size', '16px');
      document.body.appendChild(span);
      tagsWidth += span.offsetWidth;
      span.remove();

      if (tagsWidth < maxWidth) {
        arr.push(tag);
        plusLength--;
      } else {
        arr.push(`+${plusLength}`)
        break;
      }
    }

    setRemakedTags(arr);
  }, [width, order])

  const styles = {
    borderRadius: `${borderRadius.topLeft ? borderRadius.topLeft-4 : 0}px ${borderRadius.topRight ? borderRadius.topRight-4 : 0}px ${borderRadius.bottomLeft ? borderRadius.bottomLeft-4 : 0}px ${borderRadius.bottomRight ? borderRadius.bottomRight-4 : 0}px`,
    borderRadiusOuter: `${borderRadius.topLeft || 0}px ${borderRadius.topRight || 0}px ${borderRadius.bottomLeft || 0}px ${borderRadius.bottomRight || 0}px`
  }

	return (
		<CardContainer id={id} $withBorder={Boolean(order.conflicts)} $borderRadius={styles.borderRadiusOuter} >
			<BasicCard className='basic-card' styles={styles}>
				<CardContent onClick={selectCardId}>
					<CardInfo>
						<Flex $justify="space-between">
							<Title>
								<Truncate>{order.person.name}</Truncate>
							</Title>
							<OrderConfirm order={order} mode="small" />
						</Flex>
						<Flex $justify="space-between" $cursor="pointer">
							<TimeContent>
								<TimeIcon size="verySmall" />
								<TimeText>
									{visitStart} - {visitEnd}
								</TimeText>
								<Icon>
									<GuestsIcon size="verySmall" />
								</Icon>
								<TimeText>{order.participants_count}</TimeText>{order.appointment?.bypass && <img src={flash} style={{ marginLeft: '-2px' }} />}
								{order.state === State.WAITING && (
									<Tooltip label="Гость скоро придёт">
										<MenComingIcon size="verySmall" />
									</Tooltip>
								)}
								{order.state === State.EXCEEDING && (
									<Tooltip label="Гость сидит дольше">
										<TimerIcon size="verySmall" />
									</Tooltip>
								)}
                {order.deposit?.provider?.backend?.icon && (
                  <DepositWrapper>
                    <Img src={order.deposit.provider.backend.icon} $size="verySmall" />
                  </DepositWrapper>
                )}
							</TimeContent>
							<OrderResources order={order} row />
						</Flex>
            <OrderTagsShort tags={remakedTags} forOrder={true} />
					</CardInfo>
				</CardContent>
			</BasicCard>
		</CardContainer>
	);
};
